import { ref } from 'vue';
import { z } from 'zod';
import Cookies from 'js-cookie';

export const CookieList = z.record(z.string(), z.string());

/**
 * Keep track of patch transactions.
 * Used to prevent update component states multiple times.
 */
export default function useCookie() {
	const sessionCookieKeys = ref<z.infer<typeof CookieList>>({
		global: '_ga_G8MSDVMV1X',
		soesterberg: '_ga_G8MSDVMV1X',
		bussloo: '_ga_G8MSDVMV1X',
		badnieuweschans: '_ga_G8MSDVMV1X',
		berendonck: '_ga_G8MSDVMV1X',
		maarssen: '_ga_G8MSDVMV1X',
		maastricht: '_ga_G8MSDVMV1X',
	});

	const getSessionCookie = (key: string): string | null => {
		return Cookies.get(sessionCookieKeys.value[key] || sessionCookieKeys.value['global']) || null;
	};

	return {
		sessionCookieKeys,
		getSessionCookie,
	};
}
